export default __webpack_public_path__ + "static/media/smb_white_logo.05c74e72.png";